import React from 'react';
import { SmallText } from 'ds/components/typography';
import { TableColumn } from 'ds/components/table';
import { HpdViolation } from 'store/state/selectors/insights/summaryTypes';
import { ViolationTableColumn } from '../styled';
import { useLocale } from 'locale';
import styled from '@emotion/styled';
import { CurrentUnitLabel } from '../CurrentUnitLabel';
import { ColumnRendererProps } from 'components/widget/prices/prices-table/utils';

const LocationInfo = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey3};
  margin-top: 8px;
  display: flex;
  align-items: center;
`;

export const getDateColumnConfig = (isMobile: boolean): Partial<TableColumn<HpdViolation>> => ({
  sortFn: (items: HpdViolation[]) => items.sort((a, b) => +new Date(b.date) - +new Date(a.date)),
  width: isMobile ? '50%' : '15%',
  gap: 16,
  renderFn: (item) => <DateColumn isMobile={isMobile} item={item} />,
});

export const DateColumn: React.FC<ColumnRendererProps<HpdViolation>> = ({ item, isMobile }) => {
  const { formatDate } = useLocale();
  return (
    <ViolationTableColumn>
      <SmallText>
        {formatDate(item.date)}
      </SmallText>
      {isMobile ? (
        <LocationInfo>
          {item.location}
          {item.isCurrentUnit ? (
            <CurrentUnitLabel />
          ) : null}
        </LocationInfo>
      ) : null}
    </ViolationTableColumn>
  );
};
